import React, {ReactElement} from 'react'
import {useIntl} from 'react-intl'

import {guestPickerMessages} from './guestPickerMessages'

export interface GuestSplit {
  numberOfAdults: number
  numberOfChildren: number
}

/**
 * Adults/children split, e.g. "4 adults, 1 child". Children are omitted when there are none.
 */
export const GuestSplitText = ({
  numberOfAdults,
  numberOfChildren
}: GuestSplit): ReactElement => {
  const {formatMessage} = useIntl()
  const parts = [
    formatMessage(guestPickerMessages.adult, {count: numberOfAdults})
  ]
  if (numberOfChildren > 0) {
    parts.push(
      formatMessage(guestPickerMessages.child, {count: numberOfChildren})
    )
  }
  return <>{parts.join(', ')}</>
}
